import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AbilityContext } from '../../../../components/Ability'
import NotFound from '../../../NotFound'
import ShopeeLogin from './Features/LazadaLogin'
import ShopeeOrderList from './Features/LazadaOrderList'


const LazadaPage = () => {
  const ability = useContext(AbilityContext)
  return (
    <Routes>
      <Route
        path="/login"
        element={
          ability.can('read', 'Users') ? <ShopeeLogin /> : <NotFound />
        }
      />
      <Route
        path="/order"
        element={
          ability.can('read', 'Users') ? <ShopeeOrderList /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default LazadaPage
